import React from "react";
import SideMenu from "./SideMenu";

const UserLayout = ({ children }) => {
  return (
    <div>
      <div className="mt-2 mb-2 py-4">
        <h2 className="text-center font-bold text-lg sm:text-xl md:text-2xl">
          User Settings
        </h2>
      </div>

      <div className="container mx-auto px-2 sm:px-4">
        <div className="flex flex-wrap justify-around">
          <div className="w-full sm:w-3/4 md:w-1/4 px-2 m-3">
            <SideMenu />
          </div>
          <div className="w-full sm:w-3/4 md:w-2/3 px-2">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default UserLayout;
